// const ScientificStory = () => import('Views/scientificStory/index');
const StoryList = () => import('Views/scientificStory/story-list-new-ui');
const StoryDetail = () => import('Views/scientificStory/story-detail-new-ui');
const ScientificStory = () => import('Views/scientificStory/index-new-ui');

export default[
  { path: '/scientific-story', component: ScientificStory },
  { path: '/story-list', component: StoryList },
  { path: '/story-detail/:id', component: StoryDetail },
];



// WEBPACK FOOTER //
// ./src/router/scientificStory.js